module.exports = __webpack_public_path__ + "a435c848e0a429c2cfc0c23b5ba7ebde.png";